import _ from 'lodash';
import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getProgramsCategory } from './programsCategory.selectors';

export const selectCustomAdjustments = createSelector(
  getProgramsCategory,
  ({ customAdjustments }) => customAdjustments,
);

export const selectIsCustomAdjustmentsLoaded = createSelector(
  selectCustomAdjustments,
  customAdjustments => !_.isEmpty(customAdjustments),
);

export const selectCustomAdjustmentsValues = createSelector(selectCustomAdjustments, adjustments =>
  Object.values(adjustments).sort((a, b) => a.name.localeCompare(b.name)),
);

const selectFilteredCustomAdjustmentsValues = createSelector(
  selectCustomAdjustmentsValues,
  adjustmentsValues => adjustmentsValues.filter(({ isDeleted }) => !isDeleted),
);

export const selectFilteredCustomAdjustmentsOptions = createSelector(
  selectFilteredCustomAdjustmentsValues,
  adjustmentsValues =>
    adjustmentsValues.map(({ name, customAdjustmentTypeId }) => ({
      name,
      value: customAdjustmentTypeId,
    })),
);

export const selectFilteredCustomAdjustments = createSelector(
  getDebouncedSearchValue,
  selectCustomAdjustmentsValues,
  searchItems(({ name }) => [name]),
);
